import { createSelector } from '@reduxjs/toolkit';
import { StrikeMethod } from 'client/voladeum/strike-methods/types';
import { RootState } from 'store';

const strikeMethodsSlice = (state: RootState) => state.strike_methods;

export const selectStrikeMethods = createSelector(
  [strikeMethodsSlice],
  (state): StrikeMethod[] => state
);
